import * as React from 'react';
import {connect} from 'react-redux';

import {change, formValueSelector, Field} from 'redux-form';

import {nonEmpty} from 'shells/form/validation/non-empty';
import {nonNull} from 'shells/form/validation/non-null';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {Body} from 'shells/typography/body';

import {GraphQLSelectUsers} from '../../../../core/select/graphql-select-users';

import {FORM_NAME} from '../next-steps-constants';

const nextStepsSelector = formValueSelector(FORM_NAME);

// @ts-expect-error
function mapStateToProps(state): StateProps {
    return {
        notifiables: nextStepsSelector(state, 'notifiables'),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        onNotifiablesChange: (newValue?: string[] | null) => {
            dispatch(change(FORM_NAME, 'notifiables', newValue));
        },
    };
}

type StateProps = {
    notifiables: string[];
};

type DispatchProps = {
    onNotifiablesChange: (arg1?: string[] | null | undefined) => void;
};

type Props = StateProps & DispatchProps;

export function NextStepsFormNutshellNotificationComponent(props: Props) {
    return (
        <div>
            <SpacerGroup mb={8}>
                <Body>Who should receive this notification?</Body>
            </SpacerGroup>
            <Field
                name='notifiables'
                component={GraphQLSelectUsers}
                props={{
                    loggedInUserFirst: true,
                    selectedIds: props.notifiables,
                    // @ts-expect-error
                    onChange: (entities) => {
                        // @ts-expect-error
                        const notifiables = entities.map((entity) => entity.value);
                        props.onNotifiablesChange(notifiables);
                    },
                    onClearValue: () => props.onNotifiablesChange([]),
                }}
                validate={[nonNull, nonEmpty]}
            />
        </div>
    );
}

// @ts-expect-error
const connector = connect<Props, Record<any, any>, _, _, _, _>(mapStateToProps, mapDispatchToProps);
export const NextStepsFormNutshellNotification = connector(
    NextStepsFormNutshellNotificationComponent
);
